import { useQuery } from '@tanstack/react-query';

import { SkyMapAxiosServiceFactory } from '../../../../services/axios/skymap-axios-service-factory';
import { getHttpStatusCode } from '../../../api/error-handling';
import { useParams } from '../../../hooks/use-params';

const usePasswordRequestTokenExistsQuery = () => {
  const { token } = useParams();

  return useQuery<{ status: 'ACTIVE' | 'USED' | 'NOT_FOUND' }>({
    queryKey: ['fetch-password-request-token', token],
    gcTime: 0, // Fetch each time (no cache).
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    queryFn: async ({ signal }) => {
      try {
        const passwordResetToken = await SkyMapAxiosServiceFactory.instance
          .createPasswordResetTokenServiceV0()
          .getToken({
            path: {
              id: token,
            },
          });

        return {
          status: passwordResetToken.data.status,
        };
      } catch (err) {
        if (getHttpStatusCode(err) === 404) {
          return { status: 'NOT_FOUND' };
        }

        throw err;
      }
    },
  });
};

export { usePasswordRequestTokenExistsQuery };
